'use client';

import { NumberStepInput } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

import { useConfigurator } from './ConfiguratorContext';

type Props = {
  index: number;
};

export default function ConfiguratorProductSlotQuantitySelector({ index }: Props) {
  const { t } = useTranslation('webshop.productPage.configurator');
  const {
    states: { selectedUseCaseIndex, configuratorValues },
    actions: { updateConfiguratorValue }
  } = useConfigurator();

  const handleQuantityChange = (index: number) => (value: number) => {
    const updatedConfiguratorValues = (configuratorValues.get(selectedUseCaseIndex) || []).map(
      (item, slotIndex) => {
        if (index !== slotIndex) {
          return item;
        }

        return {
          ...item,
          quantity: value
        };
      }
    );

    updateConfiguratorValue(updatedConfiguratorValues);
  };

  return (
    <NumberStepInput
      value={configuratorValues.get(selectedUseCaseIndex)?.[index].quantity || 1}
      min={1}
      onChange={handleQuantityChange(index)}
      aria-label={t('productQuantity')}
      size='small'
    />
  );
}
